import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-person_green",
  "use": "icon-person_green-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-person_green\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 686.208A231.104 231.104 0 1 1 512 224a231.104 231.104 0 0 1 0 462.208z m0-64A167.104 167.104 0 1 0 512 288a167.104 167.104 0 0 0 0 334.208z\" fill=\"#4fb8cc\" p-id=\"7967\" /><path d=\"M873.984 849.472l-57.6 27.84A337.792 337.792 0 0 0 512 686.208a337.728 337.728 0 0 0-301.888 186.048l-57.152-28.8A401.728 401.728 0 0 1 512 622.208a401.728 401.728 0 0 1 361.984 227.2z\" fill=\"#4fb8cc\" p-id=\"7968\" /><path d=\"M512 960A448 448 0 1 0 512 64a448 448 0 0 0 0 896z m0 64A512 512 0 1 1 512 0a512 512 0 0 1 0 1024z\" fill=\"#4fb8cc\" p-id=\"7969\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/person_green.svg
// module id = dwSv
// module chunks = 39